// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2faVR","importantInfo":"styles_importantInfo__1tmwY"};